/* This example requires Tailwind CSS v2.0+ */
import React from "react"
import maybank from "../images/maybank.png"
import foundation from "../images/maybankFoundation.png"
import asean from "../images/ASEAN.png"
import depEd from "../images/depEd.png"
import psse from "../images/PSSE.png"
import dfat from "../images/dfat.png"

import FadeIn from 'react-fade-in'

export default function Sponsors() {
  return (
    <div className="bg-white pb-5 pt-8">
      <p className="text-center text-2xl font-semibold uppercase text-gray-600 tracking-wider">
        Supported By
      </p>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="grid items-center grid-cols-2 lg:grid-cols-3 gap-8 py-12">
            <a href="https://psse.org.ph/" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img href="" className="h-28" src={psse} alt="psse" />
            </a>
            <a href="https://www.deped.gov.ph/" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img href="" className="h-20" src={depEd} alt="depEd" />
            </a>
            <a href="https://www.dfat.gov.au/people-to-people/foundations-councils-institutes/australia-asean-council" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img className="h-20 object-contain" src={dfat} alt="dfat" />
            </a>
            <a href="https://www.maybank.com/en/index.page" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img href="" className="h-12" src={maybank} alt="maybank" />
            </a>
            <a href="https://www.maybankfoundation.com/" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img href="" className="h-12" src={foundation} alt="foundation" />
            </a>
            <a href="https://www.aseanfoundation.org/" target="__blank" className="col-span-1 flex justify-center lg:col-span-1">
              <img href="" className="h-12" src={asean} alt="asean" />
            </a>
          </div>
        </FadeIn>
      </div>
    </div>
  )
}
